




import Vue from 'vue';

export default class AppComponent extends Vue {}
